import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Settings|Roles|Permissions Table|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

type LocNameStart = 'SPSettingsRolesPermissionsTable';
export type SPSettingsRolesPermissionsTableLocNames =
	| `${LocNameStart}TitleTableCaption`
	| `${LocNameStart}LabelGroup`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelDescription`
	| `${LocNameStart}LabelFilterByGroup`
	| `${LocNameStart}ContentInstructions`;

export const spSettingsRolesPermissionsTableLocs: LocDefs<SPSettingsRolesPermissionsTableLocNames> =
	{
		SPSettingsRolesPermissionsTableTitleTableCaption: {
			defaultValue: 'Role Permissions',
			description: 'Accessibility table caption',
			displayPath: `${pathStart}Table caption`,
			displayType: 'Title',
			legacyName: 'Core/Settings.Roles.Title.PermissionsTableCaption',
			...sharedProperties,
		},
		SPSettingsRolesPermissionsTableLabelGroup: {
			defaultValue: 'Group',
			description: 'Column heading for: Group.',
			displayPath: `${pathStart}Group`,
			displayType: 'Label',
			legacyName: 'Core/Settings.Roles.ColumnHeading.Group',
			...sharedProperties,
		},
		SPSettingsRolesPermissionsTableLabelName: {
			defaultValue: 'Name',
			description: 'Column heading for: Name.',
			displayPath: `${pathStart}Name`,
			displayType: 'Label',
			legacyName: 'Core/Settings.Roles.ColumnHeading.Name',
			...sharedProperties,
		},
		SPSettingsRolesPermissionsTableLabelDescription: {
			defaultValue: 'Description',
			description: 'Column heading for: Description.',
			displayPath: `${pathStart}Description`,
			displayType: 'Label',
			legacyName: 'Core/Settings.Roles.ColumnHeading.Description',
			...sharedProperties,
		},
		SPSettingsRolesPermissionsTableLabelFilterByGroup: {
			defaultValue: 'Filter by Group',
			description: 'Label for: Filter by Group.',
			displayPath: `${pathStart}Filter by Group`,
			displayType: 'Label',
			legacyName: 'Core/Settings.Roles.FieldLabel.GroupFilter',
			...sharedProperties,
		},
		SPSettingsRolesPermissionsTableContentInstructions: {
			defaultValue:
				'If a permission is dependent on a feature (striped background), the permission will not be applied to the user account until the associated feature is enabled.',
			description: 'Permissions table instructions.',
			displayPath: `${pathStart}Instructions`,
			displayType: 'Content',
			legacyName: 'Core/Settings.Roles.Content.Instructions',
			...sharedProperties,
		},
	};

export type SPSettingsRolesPermissionsTableLocType =
	LocMap<SPSettingsRolesPermissionsTableLocNames>;
